var mp3_lib_block = document.querySelector('.block-mp3-library');
var isPlaying = false;

document.addEventListener("DOMContentLoaded", function () {

    if(mp3_lib_block){
        bindTriggers();     
    }
});

function bindTriggers(){
    let audio_event_triggers = mp3_lib_block.querySelectorAll('[data-audio]');
    audio_event_triggers.forEach(function(trigger){


        let audio_id = trigger.dataset.audio;
        let audio_obj = document.getElementById(audio_id);

        let duration_wrapper = trigger.closest(".media").querySelector('.duration');

        let minutes = Math.floor(audio_obj.duration / 60);
        let seconds = Math.floor(audio_obj.duration - minutes * 60);
        seconds = (/^\d$/.test(seconds)) ? "0" + seconds : seconds;

        if(! isNaN(minutes)&& ! isNaN(seconds)){
            duration_wrapper.innerHTML = "Duration: " + minutes + ":" + seconds;
        }

        trigger.addEventListener('click', function(event){
            event.preventDefault();

            

            let audio_id = this.dataset.audio;
            let audio_obj = document.getElementById(audio_id);

            let current_status = audio_obj.paused;
            pause_all();

            var media = audio_obj.closest(".media");
            var progress_bar = media.querySelector('[type="range"]');

            audio_obj.addEventListener("timeupdate", function() {

                var currentTime = audio_obj.currentTime;

                let minutes = Math.floor(currentTime / 60);
                let seconds = Math.floor(currentTime - minutes * 60);
                seconds = (/^\d$/.test(seconds)) ? "0" + seconds : seconds;

                // console.log(minutes,"minutes");
                // console.log(seconds,"seconds");
                progress_bar.max = audio_obj.duration;
                progress_bar.value = currentTime;

                let progress = currentTime / audio_obj.duration * 100;
                progress_bar.style.background = `linear-gradient(to right, #b9906b ${progress}%, #ccc ${progress}%)`;
                // console.log("Playing - Progress: " + minutes + ":" + seconds);

                if(! isNaN(minutes)&& ! isNaN(seconds)){
                    // console.log("should update");
                    media.setAttribute('data-after', "Playing - Progress: " + minutes + ":" + seconds);
                }

            });

            

            // console.log(audio_obj,"obj");
            // console.log(audio_id,"id");
            // console.log(isPlaying,"is playing");

            if(current_status){
                audio_obj.play();
                this.closest(".media").classList.add("playing");
                this.closest(".media").classList.remove("paused");
            } else {
                audio_obj.pause();
                this.closest(".media").classList.add("paused");
                this.closest(".media").classList.remove("playing");
            }

        });

        
    });


    let progress_bars = mp3_lib_block.querySelectorAll('[type="range"]');

    progress_bars.forEach(function(progress_bar){
        console.log(progress_bar,"1 bar");
        progress_bar.addEventListener("change", function(event) {
  
            let media = this.closest(".media");
            let seekTo = this.value;
            let audio = media.querySelector('audio');

            audio.currentTime = seekTo;
            audio.play();
        });

        progress_bar.addEventListener("mousedown", function(event) {
            let media = this.closest(".media");
            let audio = media.querySelector('audio');
            audio.pause();
        });
    });
}

function pause_all(){

    let audios = mp3_lib_block.querySelectorAll('audio');
    audios.forEach(function(audio){
        audio.pause();
        audio.closest(".media").classList.add("paused");
        audio.closest(".media").classList.remove("playing");
    });

}